import fetch from 'isomorphic-fetch';

interface FetchSavedAds {
    advertId: number;
    action: 'add' | 'remove';
    token: string;
}

export const fetchOptions: Parameters<typeof fetch>[1] = {
    method: 'POST',
    headers: {
        accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
};

const fetchSavedAds = async ({ action, advertId, token }: FetchSavedAds) =>
    await fetch(`/savedads/${advertId}/${action}?token=${token}`, fetchOptions);

export default fetchSavedAds;
